import { Typography } from '@mui/material';
import LoginForm from './LoginForm';
import ButtonsTextGoTo from '../../components/Button/ButtonTextGo';
import LoginCardNew from './LoginCardNew';
import { useTranslation } from '../../language';



export default function LoginCard() {

const { t, language } = useTranslation();

return (

<LoginCardNew
      authform = { <LoginForm /> }
      content = {<>

            <Typography variant="subtitle1" gutterBottom sx={{mt: {xs: '2rem', fontWeight: 400 } }}> 
                  {t("login_acc")}  </Typography>
                  <ButtonsTextGoTo to="/RegisterPage2Col" name={t("login_reg")}  />
            
            <Typography variant="subtitle1" gutterBottom sx={{mt: '1rem', fontWeight: 400 }}>
                  {t("login_forgot")}</Typography>
                  <ButtonsTextGoTo to="/ForgotWelcome" name={t("login_reset")} />
      </>
     }                    
   />

  )
}